var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group position-relative"},_vm._l((_vm.uploads),function(file){return _c('uploads-list-item',{key:file._id,attrs:{"file":file,"isRemoved":_vm.removed.includes(file._id)},on:{"remove":_vm.onRemove,"restore":_vm.onRestore}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }